import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AuditComponent,
  DeliveryExceptionsComponent,
  ExceptionsComponent,
  FailuresComponent,
  HistoryComponent,
  ModifierExceptionComponent,
  PricingExceptionsComponent,
  SubstitutionsExceptionComponent,
  SyncExceptionsComponent,
} from './components';
import { ReportsComponent } from './reports.component';
import { GroupTypeIds, RoleCodes, roleArray } from '@auth';
import { RouteGuard } from 'src/app/auth/route.guard';
const routes: Routes = [
  {
    path: '',
    component: ReportsComponent,
    canActivate: [RouteGuard],
    children: [
      {
        path: 'history',
        component: HistoryComponent,
      },
      {
        path: 'sync-exceptions',
        component: SyncExceptionsComponent,
      },
      {
        path: 'audit',
        component: AuditComponent,
        // Hide Tier Audit for AvailabilityOnly users (matches frontend show/hide logic)
        data: { roles: roleArray([], [RoleCodes.AvailabilityOnly]) },
      },
      {
        path: 'failures',
        component: FailuresComponent,
        data: { roles: roleArray([RoleCodes.Admin]) },
      },
      {
        path: 'exceptions',
        component: ExceptionsComponent,
        // Hide Exceptions & Rules for AvailabilityOnly users (matches frontend show/hide logic)
        data: { roles: roleArray([], [RoleCodes.AvailabilityOnly]) },
        children: [
          {
            path: 'delivery/:type',
            component: DeliveryExceptionsComponent,
            data: { roles: roleArray([], [RoleCodes.AvailabilityOnly]) },
          },
          {
            path: 'pricing/:type',
            component: PricingExceptionsComponent,
            data: { roles: roleArray([], [RoleCodes.AvailabilityOnly]) },
          },
          {
            path: 'modifiers/:type',
            component: ModifierExceptionComponent,
            data: { roles: roleArray([], [RoleCodes.AvailabilityOnly]) },
          },
          {
            path: 'substitutions',
            component: SubstitutionsExceptionComponent,
            data: { roles: [GroupTypeIds.Member] },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsRoutingModule {}
